export { ImageCollage } from "./ImageCollage";
export type { ImageCollageProps } from "./ImageCollage";
